__turbopack_context__.v({
  "blueTheme": "BusinessGain-module__Nn6ShW__blueTheme",
  "checkmark": "BusinessGain-module__Nn6ShW__checkmark",
  "description": "BusinessGain-module__Nn6ShW__description",
  "icon": "BusinessGain-module__Nn6ShW__icon",
  "itemText": "BusinessGain-module__Nn6ShW__itemText",
  "list": "BusinessGain-module__Nn6ShW__list",
  "resultItem": "BusinessGain-module__Nn6ShW__resultItem",
  "resultsSection": "BusinessGain-module__Nn6ShW__resultsSection",
  "title": "BusinessGain-module__Nn6ShW__title",
});
